type AdvertiserNameInput = {
    name: string;
};
export default class AdvertiserName {
    private data: AdvertiserNameInput;
    type = 'advertiserName' as const;

    constructor(input: AdvertiserNameInput) {
        this.data = input;
    }

    get id() {
        return this.data.name;
    }

    get label() {
        return this.data.name;
    }
}
